module.exports = __webpack_public_path__ + "static/media/mark-how-it-looks.e738b761.png";